<template>
  <div class="punch-page">
    <div class="punch-card">
      <!-- Clock -->
      <div class="punch-clock">
        <span class="clock-digit">{{ hours }}</span>
        <span class="clock-sep">:</span>
        <span class="clock-digit">{{ minutes }}</span>
        <span class="clock-sec">{{ seconds }}</span>
      </div>
      <div class="punch-date">{{ now }}</div>

      <!-- Punch buttons -->
      <div class="punch-buttons">
        <button class="punch-btn start" :class="{ punched: isPunchedTimeStart }" @click="punchIn" :disabled="isPunchedTimeStart">
          <div class="punch-btn-label">スタート</div>
          <div class="punch-btn-time">{{ time_start_hours }}<span>:</span>{{ time_start_minutes }}</div>
        </button>
        <button class="punch-btn stop" :class="{ punched: isPunchedTimeStop }" @click="punchOut" :disabled="!isPunchedTimeStart || isPunchedTimeStop">
          <div class="punch-btn-label">ストップ</div>
          <div class="punch-btn-time">{{ time_stop_hours }}<span>:</span>{{ time_stop_minutes }}</div>
        </button>
      </div>

      <!-- Summary -->
      <div class="punch-summary">
        <div class="summary-row">
          <span class="summary-label">勤務時間</span>
          <span class="summary-value">{{ working_hours }}<small>:</small>{{ working_minutes }}</span>
        </div>
        <div class="summary-row summary-row-edit" @click="showBreakEdit" v-if="isPunchedTimeStart">
          <span class="summary-label">休憩時間 <i class="fas fa-edit" style="font-size:11px;color:#a0aec0;"></i></span>
          <span class="summary-value">{{ basic_break_hours }}<small>:</small>{{ basic_break_minutes }}</span>
        </div>
        <div class="summary-row" v-else>
          <span class="summary-label">休憩時間</span>
          <span class="summary-value">{{ basic_break_hours }}<small>:</small>{{ basic_break_minutes }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">残業時間</span>
          <span class="summary-value">{{ overtime_hours }}<small>:</small>{{ overtime_minutes }}</span>
        </div>
      </div>
    </div>

    <!-- 休憩時間編集モーダル -->
    <div v-if="showBreakPicker" class="break-modal-overlay" @click.self="showBreakPicker = false">
      <div class="break-modal">
        <div class="break-modal-header">
          <h6 style="font-weight:700;margin:0;">休憩時間</h6>
          <button class="break-modal-close" @click="showBreakPicker = false">&times;</button>
        </div>
        <div class="break-modal-body">
          <div class="break-selects">
            <select class="break-select" v-model="breakPickerHour">
              <option v-for="h in 24" :key="h-1" :value="h-1">{{ (h-1).toString().padStart(2, '0') }}</option>
            </select>
            <span class="break-sep">:</span>
            <select class="break-select" v-model="breakPickerMinute">
              <option v-for="m in 60" :key="m-1" :value="m-1">{{ (m-1).toString().padStart(2, '0') }}</option>
            </select>
          </div>
        </div>
        <div class="break-modal-footer">
          <button class="btn-break-confirm" @click="confirmBreakEdit">確定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hours: '00',
      minutes: '00',
      seconds: '00',
      now: this.$moment().format('YYYY/MM/DD'),
      timecard: {
        id: null,
        time_start: null,
        time_stop: null,
        basic_break_hours: null,
        overtime_hours: null,
        working_hours: null,
      },
      position: null,
      store_id: 0,
      showBreakPicker: false,
      breakPickerHour: 0,
      breakPickerMinute: 0,
    }
  },
  beforeMount() {
    this.clock();
    this.fetchTimecard();
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.position = position.coords;
      });
    }
    this.store_id = this.$store.getters.shop;
  },
  computed: {
    time_start_hours() {
      return this.timecard.time_start ? this.$moment(this.timecard.time_start).hours().toString().padStart(2, '0') : '--';
    },
    time_start_minutes() {
      return this.timecard.time_start ? this.$moment(this.timecard.time_start).minutes().toString().padStart(2, '0') : '--';
    },
    time_stop_hours() {
      return this.timecard.time_stop ? this.$moment(this.timecard.time_stop).hours().toString().padStart(2, '0') : '--';
    },
    time_stop_minutes() {
      return this.timecard.time_stop ? this.$moment(this.timecard.time_stop).minutes().toString().padStart(2, '0') : '--';
    },
    isPunchedTimeStart() {
      return this.timecard.time_start != null;
    },
    isPunchedTimeStop() {
      return this.timecard.time_stop != null;
    },
    working_hours() {
      return this.timecard.working_hours ? this.$moment(this.timecard.working_hours).hours().toString().padStart(2, '0') : '--';
    },
    working_minutes() {
      return this.timecard.working_hours ? this.$moment(this.timecard.working_hours).minutes().toString().padStart(2, '0') : '--';
    },
    basic_break_hours() {
      return this.timecard.basic_break_hours ? this.$moment(this.timecard.basic_break_hours).hours().toString().padStart(2, '0') : '--';
    },
    basic_break_minutes() {
      return this.timecard.basic_break_hours ? this.$moment(this.timecard.basic_break_hours).minutes().toString().padStart(2, '0') : '--';
    },
    overtime_hours() {
      return this.timecard.overtime_hours ? this.$moment(this.timecard.overtime_hours).hours().toString().padStart(2, '0') : '--';
    },
    overtime_minutes() {
      return this.timecard.overtime_hours ? this.$moment(this.timecard.overtime_hours).minutes().toString().padStart(2, '0') : '--';
    },
  },
  methods: {
    clock() {
      const nowDate = this.$moment().format('YYYY/MM/DD');
      this.hours = this.$moment().hours().toString().padStart(2, '0');
      this.minutes = this.$moment().minutes().toString().padStart(2, '0');
      this.seconds = this.$moment().seconds().toString().padStart(2, '0');
      // 日付が変わったらリセット
      if (this.now !== nowDate) {
        this.now = nowDate;
        this.timecard = { id: null, time_start: null, time_stop: null, basic_break_hours: null, overtime_hours: null, working_hours: null };
        this.fetchTimecard();
      }
      setTimeout(this.clock, 1000);
    },
    setTimecard(timecard) {
      this.timecard.id = timecard.id;
      this.timecard.time_start = timecard.time_start != null ? this.$moment(timecard.time_start) : null;
      this.timecard.time_stop = timecard.time_stop != null ? this.$moment(timecard.time_stop) : null;
      this.timecard.working_hours = timecard.working_hours != '00:00' ? this.$moment(`${this.$moment().format('YYYY-MM-DD')} ${timecard.working_hours}:00`) : null;
      if (this.isPunchedTimeStart && this.isPunchedTimeStop && this.timecard.working_hours == null) {
        this.timecard.working_hours = this.$moment(`${this.$moment().format('YYYY-MM-DD')} ${timecard.working_hours}:00`);
      }
      this.timecard.basic_break_hours = timecard.basic_break_hours != '00:00' ? this.$moment(`${this.$moment().format('YYYY-MM-DD')} ${timecard.basic_break_hours}`) : null;
      this.timecard.overtime_hours = timecard.overtime_hours != null ? this.$moment(`${this.$moment().format('YYYY-MM-DD')} ${timecard.overtime_hours}:00`) : null;
    },
    fetchTimecard() {
      this.$http.get(process.env.VUE_APP_API_PATH + `/staff/shop/${this.$store.getters.shop}/timecard/v2/${this.$moment().format('YYYY-MM-DD')}`)
      .then(response => {
        if (response.data.success) {
          const data = response.data.data;
          if (data.timecard) {
            this.setTimecard(data.timecard);
          }
        }
      })
      .catch(error => { console.log(error); });
    },
    punchIn() {
      if (this.isPunchedTimeStart) return;
      this.$http.post(process.env.VUE_APP_API_PATH + `/staff/shop/${this.store_id}/timecard/in`, {
        time_start: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        latitude: this.position?.latitude,
        longitude: this.position?.longitude
      })
      .then(response => {
        if (response.data.success && response.data.data.timecard) {
          this.setTimecard(response.data.data.timecard);
        }
      })
      .catch(error => { console.log(error); });
    },
    punchOut() {
      if (!this.isPunchedTimeStart || this.isPunchedTimeStop) return;
      this.$http.put(process.env.VUE_APP_API_PATH + `/staff/shop/${this.store_id}/timecard/out`, {
        id: this.timecard.id,
        time_stop: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        latitude: this.position?.latitude,
        longitude: this.position?.longitude
      })
      .then(response => {
        if (response.data.success && response.data.data.timecard) {
          this.setTimecard(response.data.data.timecard);
        }
      })
      .catch(error => { console.log(error); });
    },
    showBreakEdit() {
      if (!this.timecard.id) return;
      this.breakPickerHour = parseInt(this.basic_break_hours) || 0;
      this.breakPickerMinute = parseInt(this.basic_break_minutes) || 0;
      this.showBreakPicker = true;
    },
    confirmBreakEdit() {
      const time = `${this.breakPickerHour.toString().padStart(2, '0')}:${this.breakPickerMinute.toString().padStart(2, '0')}`;
      this.$http.post(process.env.VUE_APP_API_PATH + `/staff/shop/${this.store_id}/timecard/breaktime`, {
        timecard_id: this.timecard.id,
        time: time,
      })
      .then(() => {
        this.showBreakPicker = false;
        this.fetchTimecard();
        this.$toast.success('休憩時間を更新しました');
      })
      .catch(() => { this.$toast.error('更新に失敗しました'); });
    },
  }
}
</script>

<style scoped>
.punch-page {
  display: flex;
  justify-content: center;
}

.punch-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 32px 28px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

/* Clock */
.punch-clock {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin-bottom: 4px;
}

.clock-digit {
  font-size: 48px;
  font-weight: 700;
  color: #1a202c;
  font-variant-numeric: tabular-nums;
  width: 65px;
  display: inline-block;
}

.clock-sep {
  font-size: 40px;
  font-weight: 300;
  color: #a0aec0;
}

.clock-sec {
  font-size: 20px;
  font-weight: 500;
  color: #a0aec0;
  width: 30px;
  margin-left: 4px;
}

.punch-date {
  font-size: 16px;
  color: #718096;
  margin-bottom: 28px;
  font-weight: 500;
}

/* Buttons */
.punch-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 28px;
}

.punch-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-radius: 12px;
  border: 2px solid #049C4C;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
}

.punch-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(4,156,76,0.2);
}

.punch-btn:disabled {
  cursor: default;
}

.punch-btn.punched {
  background: #049C4C;
  color: #fff;
  border-color: #049C4C;
}

.punch-btn.stop {
  border-color: #3182ce;
}

.punch-btn.stop.punched {
  background: #3182ce;
  border-color: #3182ce;
}

.punch-btn-label {
  font-weight: 600;
  font-size: 16px;
}

.punch-btn-time {
  font-weight: 700;
  font-size: 20px;
  font-variant-numeric: tabular-nums;
}

.punch-btn-time span {
  margin: 0 2px;
}

/* Summary */
.punch-summary {
  background: #f7fafc;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #e2e8f0;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.summary-row + .summary-row {
  border-top: 1px solid #edf2f7;
}

.summary-label {
  font-size: 15px;
  color: #4a5568;
  font-weight: 500;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  font-variant-numeric: tabular-nums;
}

.summary-value small {
  font-size: 16px;
  color: #a0aec0;
  margin: 0 1px;
}

/* Mobile */
@media (max-width: 480px) {
  .punch-card { padding: 24px 20px; }
  .clock-digit { font-size: 40px; width: 55px; }
  .clock-sep { font-size: 32px; }
  .punch-btn { padding: 12px 20px; }
}

.summary-row-edit { cursor: pointer; border-radius: 8px; padding: 8px 12px !important; transition: background 0.15s; }
.summary-row-edit:hover { background: #f0fff4; }

.break-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 1050; display: flex; align-items: center; justify-content: center; }
.break-modal { background: #fff; border-radius: 16px; width: 300px; max-width: 90vw; box-shadow: 0 20px 60px rgba(0,0,0,0.2); overflow: hidden; }
.break-modal-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #edf2f7; }
.break-modal-close { border: none; background: none; font-size: 22px; color: #718096; cursor: pointer; }
.break-modal-body { padding: 20px; }
.break-selects { display: flex; align-items: center; justify-content: center; gap: 8px; }
.break-select { font-size: 24px; font-weight: 700; padding: 10px 16px; border: 2px solid #d2d6dc; border-radius: 10px; text-align: center; width: 100px; -webkit-appearance: none; appearance: none; background: #fff; }
.break-select:focus { border-color: #049C4C; outline: none; }
.break-sep { font-size: 28px; font-weight: 700; color: #a0aec0; }
.break-modal-footer { padding: 14px 18px; border-top: 1px solid #edf2f7; }
.btn-break-confirm { width: 100%; padding: 12px; background: #049C4C; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; }
.btn-break-confirm:hover { background: #038a42; }
</style>
